"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var tslib_1 = require("tslib");
var defaultStrategy_1 = require("./defaultStrategy");
function resolveRetryConfig(input) {
  var maxRetries = input.maxRetries === undefined ? 3 : input.maxRetries;
  return tslib_1.__assign(tslib_1.__assign({}, input), {
    maxRetries: maxRetries,
    retryStrategy: input.retryStrategy || new defaultStrategy_1.ExponentialBackOffStrategy(maxRetries)
  });
}
exports.resolveRetryConfig = resolveRetryConfig;